import { useEffect, useRef } from 'react';

import InsigniaIcon from '@/components/molecules/InsigniaIcon';

export default function BrandPulse() {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const rings = container.querySelectorAll<HTMLElement>('.pulse-ring');
    let rafId: number;

    const animate = (t: number) => {
      rings.forEach((ring, i) => {
        const delay = i * 400;
        const period = 2000;
        const phase = ((t - delay) % period) / period;
        if (phase < 0) {
          ring.style.transform = 'scale(0.4)';
          ring.style.opacity = '0';
          return;
        }
        const scale = 0.4 + phase * 0.9;
        const opacity = 0.4 * (1 - phase);
        ring.style.transform = `scale(${scale})`;
        ring.style.opacity = String(opacity);
      });
      rafId = requestAnimationFrame(animate);
    };
    rafId = requestAnimationFrame(animate);

    return () => cancelAnimationFrame(rafId);
  }, []);

  return (
    <div
      ref={containerRef}
      className="relative w-[140px] h-[140px] mx-auto mb-4"
      aria-hidden="true"
    >
      <div className="pulse-ring absolute inset-0 rounded-full border-2 border-primary" />
      <div className="pulse-ring absolute inset-0 rounded-full border-2 border-primary" />
      <div className="pulse-ring absolute inset-0 rounded-full border-2 border-primary" />
      <div className="absolute inset-0 flex items-center justify-center">
        <InsigniaIcon width={50} height={48} animated={false} />
      </div>
    </div>
  );
}
